import { render } from "./bestFootwearCombination.vue?vue&type=template&id=635f1052&scoped=true&ts=true"
import script from "./bestFootwearCombination.vue?vue&type=script&lang=ts"
export * from "./bestFootwearCombination.vue?vue&type=script&lang=ts"

import "./bestFootwearCombination.vue?vue&type=style&index=0&id=635f1052&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635f1052"]])

export default __exports__